import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../context/LanguageContext";
import { BUSINESS } from "../data/siteConfig";

const ResultsGallery = () => {
  const { t, isRtl } = useLanguage();
  const images = BUSINESS.images.results;

  return (
    <section id="results" data-testid="results-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader
          eyebrow={t.results.eyebrow}
          heading={t.results.heading}
          sub={t.results.sub}
        />

        <div className="mt-16 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
          {images.map((img, i) => (
            <Reveal
              key={img.src}
              delay={i * 0.08}
              className={i === 0 ? "col-span-2 md:row-span-2" : ""}
            >
              <figure
                data-testid={`results-image-${i + 1}`}
                className={`group relative overflow-hidden rounded-2xl shadow-[0_8px_30px_rgba(28,27,26,0.06)] ${
                  i === 0 ? "aspect-[4/5] md:aspect-auto md:h-full" : "aspect-[4/5]"
                }`}
              >
                <img
                  src={img.src}
                  alt={isRtl ? img.altAr : img.altEn}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <figcaption className="absolute bottom-4 start-4 rounded-full bg-white/85 px-3.5 py-1.5 text-xs font-semibold text-ink shadow-sm backdrop-blur-sm">
                  {t.results.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResultsGallery;
